module.exports = __webpack_public_path__ + "img/about_tr.ea474157.png";